import { useTranslation } from "react-i18next";
import { Button } from "@material-ui/core";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

/**
 * @function HovmollerChartDialog
 * @description
 * Dialog to get informations for Hovmöller chart
 * @param {Boolean} show dialog on screen if true
 * @param {Function} callback function to close the dialog, it should change open to false in parent component
 */
const HovmollerChartDialog = ({ open, close }) => {
  const [t] = useTranslation();

  return (
    <div>
      <Dialog open={open}>
        <DialogContent>
          <DialogContentText>
            {t("forms.hovmoller.hovmollerInfoDialog")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => close()}>
            {t("forms.shorelineAnalysis.close")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HovmollerChartDialog;
